import styled from "styled-components";

export const Container = styled.div `

    margin-top: 30px;

    h2 {
        margin-bottom: 10px;
    }

`

export const Content = styled.div `

    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;

    a {
        display: flex;
        flex-direction: column;
        align-items: start;
        padding: 15px;
        border-radius: 5px;
        font-size: .85rem;
        background: ${props => props?.backgroundColor ? `${props.backgroundColor}aa` : '#006070'};
        cursor: pointer;
        border: 1px solid #606060;
        box-shadow: 3px 3px 10px 2px #00000050;
        color: #fff;
        transition: all .3s ease;
    }
/*
    a:nth-child(1) {
        background: #006070;
    }

    a:nth-child(2) {
        background: #008851;
    }

    a:nth-child(3) {
        background: #353535;
    }

    a:nth-child(4) {
        background: #006070;
    }

    a:nth-child(5) {
        background: #008851;
    }

    a:nth-child(6) {
        background: #353535;
    }*/

    a:hover {
        opacity: .8;
    }

    a header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin-bottom: 20px;
    }

    a main {
        display: flex;
        justify-content: start;
        align-items: start !important;
        width: 100%;
    }

    a main span {
        text-align: start;
        width: 100%;
    }

    @media (max-width: 1100px) {

        display: grid;
        grid-template-columns: repeat(2, 1fr);

    }

    @media (max-width: 600px) {

        display: grid;
        grid-template-columns: repeat(1, 1fr);

    }
`